import React from 'react';
import { Modal, Button } from 'react-bootstrap'

class ModalConfirm extends React.Component {
	onYes = null;
	onNo = null;

	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return { visible: false };
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ visible: nextProps.visible });
	}

	open = (question, onYes, onNo) => {
		this.setState({ visible: true, question: question }, function () {
			this.onYes = onYes;
			this.onNo = onNo;
		});
	}

	yes = () => {
		this.setState({ visible: false }, function () {
			if (this.onYes !== null && this.onYes !== undefined)
				this.onYes();

			this.onNo = null;
			this.onYes = null;
		});
	}

	no = () => {
		this.setState({ visible: false }, function () {
			if (this.onNo !== null && this.onNo !== undefined)
				this.onNo();

			this.onNo = null;
			this.onYes = null;
		});
	}

	render() {
		return (
			<React.Fragment>
				<Modal show={this.state.visible} onHide={this.no}>
					<Modal.Header>
						<Modal.Title>Confirmation Required</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div dangerouslySetInnerHTML={{ __html: this.state.question }} />
					</Modal.Body>
					<Modal.Footer>
						<Button bsStyle="link" onClick={this.no}>No</Button>
						<Button bsStyle="success" onClick={this.yes} autoFocus>Yes</Button>
					</Modal.Footer>
				</Modal>
			</React.Fragment>)
	}
}

export default ModalConfirm;



// WEBPACK FOOTER //
// ./src/fw/modals/confirm/Confirm.js